import { z } from 'zod'
import { httpUrlSchema } from '../helpers/asset-ref.js'

/**
 * Where to send the browser next — a Stripe-hosted page.
 *
 * http(s) only: the app hands it to `window.location.assign`, and Zod's own URL
 * check passes `javascript:` and `data:`, which assigning would run.
 */
export const billingRedirectDtoSchema = z.object({ url: httpUrlSchema })

export type BillingRedirectDto = z.infer<typeof billingRedirectDtoSchema>
